import { useFlags } from 'launchdarkly-react-client-sdk';
import NsContent from 'components/common/ns-content/NsContent';
import { useSelector, shallowEqual } from 'react-redux';

import { NsList } from 'components/common/ns-list/NsList';
import { Feature } from 'components/common/feature/Feature';
import { NsLandmark } from 'components/common/ns-landmark/NsLandmark';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { QuoteSection } from 'components/common/quote-section/QuoteSection';
import { ToggleJourney } from 'components/app/routes/ToggleJourney';
import { selectors as meterTypeSelectors } from 'state/meter-type/meter-type-slice';
import { NsStopgap } from 'components/common/ns-stopgap/NsStopgap';

import BannerImg from 'assets/images/banner-image-winback.jpg';

const { selectIsLoading: selectIsLoadingMeterType } = meterTypeSelectors;

export const testId = 'VoiceSalesWinbackTestId';

export const VoiceSalesWinback = () => {
  const { allowJourneyVoicesalesWinback } = useFlags();
  const isLoadingMeterType = useSelector(
    selectIsLoadingMeterType,
    shallowEqual
  );

  if (isLoadingMeterType) {
    return <NsStopgap />;
  }

  return (
    <Feature
      feature={allowJourneyVoicesalesWinback}
      inactiveComponent={<ToggleJourney off />}
    >
      <div data-testid={testId}>
        <NsLandmark
          type="valley"
          image={BannerImg}
          heading="Winback – Agent Journey"
          ratio="16x9"
        >
          <div>
            <p>
              If the customer was an NEP customer, then please quote using this
              journey.
            </p>
            <p>
              If the customer was a CLASSIC customer, then please assess if the
              customer may be eligible for NEP by using the criteria below.
            </p>
            <NsList>
              {[
                'If eligible, then please quote using this journey',
                'If customer is not eligible on NEP, please complete winback on SAP'
              ]}
            </NsList>
          </div>
        </NsLandmark>
        <NsPanel>
          <NsContent>
            <h5>Customer Eligibility</h5>
            <NsList>
              {[
                'Must be a credit customer paying by monthly fixed Direct Debit or paying on receipt of the bill',
                'If customer is already with British Gas, please follow BAU Change tariff conversation',
                'For home move acquisition, please use BAU AWB wizard or NEP HMV Journey',
                `For customers who want an EV tariff please check that they have a working SMART meter that is sending reads to their current provider. If they do not have a SMART meter or it isn't sending reads please follow the SAP journey.`
              ]}
            </NsList>
            <h5>
              To make sure your customer can benefit from our tariffs check they
              are happy with the following:
            </h5>
            <NsList>
              {[
                'If the customer has a Smart meter please mention to the customer that “their meter may no longer work as smart meter and customer might need to submit their readings for some time."',
                'Confirm if the customer is happy to manage their account online and receive email correspondence',
                'If customer has paper bills then request email and then change post Winback'
              ]}
            </NsList>
          </NsContent>
          <QuoteSection title="Get a quote" />
        </NsPanel>
      </div>
    </Feature>
  );
};

export default VoiceSalesWinback;
